import React from 'react';
import StatuspageContactPage from './statuspage-contact';

export default function render(entry, pageTree) {
    return <StatuspageContactPage entry={entry} pageTree={pageTree} />;
}
